import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Button } from '../../../components';
import FieldCheckboxes from '../../../components/pdf/field-checkboxes';
import { setPdfField } from '../../../features/event/slice';
import { useInternationalization } from '../../../features/i18n';

const FieldPopupContent = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const {
    id
  } = useSelector(state => state.eventForm.data)
  const {
    pdf_field
  } = useSelector(state => state.event)
  const { translate } = useInternationalization()

  const handleSubmit = () => {
    history.push(`/event-report/${id}`)
  }

  const fieldsByCategory = {
    cover: {
      label: 'Cover',
      fields: [
        {
          name: 'cover_title',
          label: translate('GENERAL', 'title'),
        },
        {
          name: 'cover_main_image',
          label: translate('GENERAL', 'main_image'),
        },
        {
          name: 'cover_logo',
          label: "Logo",
        },
        {
          name: 'cover_name',
          label: translate('ORGANIZATION', 'name'),
        },
        {
          name: 'cover_approach',
          label: translate('APPROACH', 'singular'),
        },
        {
          name: 'cover_issue',
          label: translate('ISSUE', 'singular'),
        },
        {
          name: 'cover_datetime',
          label: translate('GENERAL', 'date_and_time'),
        },
        {
          name: 'cover_location',
          label: translate('GENERAL', 'location'),
        },
        {
          name: 'cover_type',
          label: translate('SEARCH', 'type'),
        },
        {
          name: 'cover_price',
          label: translate('GENERAL', 'price'),
        }
      ]
    },
    detail: {
      label: translate('EVENT', 'details'),
      fields: [
        {
          name: 'detail_title',
          label: translate('GENERAL', 'title'),
        },
        {
          name: 'detail_image',
          label: translate('GENERAL', 'image'),
        },
        {
          name: 'detail_description',
          label: translate('GENERAL', 'description'),
        }
      ]
    },
    other: {
      label: translate('GENERAL', 'other'),
      fields: [
        {
          name: 'other_testimonial',
          label: translate('GENERAL', 'testimonial'),
        },
        {
          name: 'other_gallery',
          label: translate('GENERAL', 'gallery'),
        },
        {
          name: 'other_guests',
          label: translate('EVENT', 'guests'),
        }
      ]
    }
  }

  const handleCheckbox = (e) => {
    console.log({e})
    if(e.target){
      dispatch(setPdfField({...pdf_field, [e.target.name]: e.target.checked}))
    }
  }

  return <>
    <div className="mb-8">
      <FieldCheckboxes
        fieldsByCategory={fieldsByCategory}
        onChange={handleCheckbox}
        map={pdf_field}
      />
    </div>

    <Button
      className="inline-block w-auto mx-auto"
      onClick={handleSubmit}
    >
      {translate('GENERAL', 'submit')}
    </Button>
  </>
}

export default FieldPopupContent
